$(document).ready(function () {
    $('body').TopBtn();
    $('.toggle-caution').Folding({open: true});

    pageMain.init();
});

window.pageMain = (function(){
    const init = ()=>{
        labelControll();
        layer.init();
    };
    const labelControll = ()=>{
        $('.survey__input-box label').on('click', function(){
            let $el = $(this).closest('.survey__input-box');
            if( $el.length ) $el.find('.survey__text input[type="text"]').prop('disabled', true);
            if( $(this).data('label') ){
                setTimeout(()=>{
                    $('.' + $(this).data('label')).prop('disabled', false).focus();
                }, 5);
            }
        });
    };
    const layer = (()=>{
        let layer1;
        let init = ()=>{
            layer1 = new nc.promokit.Layer({
                'el': '#layer-survey',
                'fade': true,
                'esc': true,
                'dim': true,
                'dimClickClose': true,
            });
            $('.p-layer__btn').on('click', close );
        };
        let open = ()=>{
            layer1.open();
        };
        let close = ()=>{
            layer1.close();
        };
        return{
            init, open, close
        }
    })();
    return{
        init, layer
    }
})();



// WEBPACK FOOTER //
// ./src/js/index.js